import { render, staticRenderFns } from "./BarPaiHangBang.vue?vue&type=template&id=5ed3821e&scoped=true"
import script from "./BarPaiHangBang.vue?vue&type=script&lang=js"
export * from "./BarPaiHangBang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3821e",
  null
  
)

export default component.exports